$(document).ready(function () {  
  if($('.banners_list .slide_box').length > 1){  
    $('.banners_list').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
  }

  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  }); 

    $(".best-seller-slider").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  }); 

  

  $('.review_carousal').slick({
  	  arrows: false,
  	  dots: true,
  	  infinite: true,
  	  speed: 300,
  	  slidesToShow: 3,
	  responsive: [
    {
      breakpoint: 1150,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  
});


// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");

